import React, { useState } from "react";
import copy from "copy-to-clipboard";
import { TableRow, TableCell } from "../../ui/table";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { Pencil, Copy, Check } from "lucide-react";
import LinkToggle from "./LinkToggle";

/**
 * Secondary Link Row Component
 * Modernized with shadcn components - Row item for secondary links table
 */
function SecondaryLink_row(props) {
    const { 
        userName, 
        createdOn, 
        linkType, 
        linkSuffix, 
        groupNumberId, 
        objectUID,
        objectUid,
        groupNumber, 
        isActive, 
        signupCount,
        toggle_add_edit_popup
    } = props;

    const [copied, setCopied] = useState(false);
    const [isActiveState, setIsActiveState] = useState(isActive);

    const handleCopy = () => {
        copy(window.location.origin + "/signup/" + linkSuffix);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleEdit = () => {
        const event = {
            currentTarget: {
                getAttribute: (attr) => {
                    const attrs = {
                        assigneduser: userName,
                        groupnumberid: groupNumberId,
                        linktype: linkType,
                        linksuffix: linkSuffix,
                        objectuid: objectUID || objectUid,
                        groupnumber: groupNumber
                    };
                    return attrs[attr];
                }
            },
            stopPropagation: () => {}
        };
        toggle_add_edit_popup(event);
    };

    const handleToggle = () => {
        setIsActiveState(!isActiveState);
    };

    if (!userName) return null;

    return (
        <TableRow className="hover:bg-brand-light-2/30">
            <TableCell className="font-medium">{userName}</TableCell>
            <TableCell>{groupNumber}</TableCell>
            <TableCell>{createdOn}</TableCell>
            <TableCell>
                <Badge variant="outline" className="text-xs">
                    {linkType}
                </Badge>
            </TableCell>
            <TableCell className="font-mono text-sm">{linkSuffix}</TableCell>
            <TableCell className="text-center">{signupCount || 0}</TableCell>
            <TableCell className="text-right">
                <div className="flex items-center justify-end gap-2">
                    <LinkToggle 
                        assigneduser={userName}
                        groupnumberid={groupNumberId}
                        linktype={linkType}
                        linksuffix={linkSuffix}
                        objectuid={objectUID || objectUid}
                        groupnumber={groupNumber}
                        isactive={isActive}
                        deactivated={handleToggle}
                    />
                    {isActiveState && (
                        <>
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleEdit}
                                className="h-8 w-8 p-0"
                            >
                                <Pencil className="h-4 w-4" />
                            </Button>
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleCopy}
                                className="h-8 w-8 p-0"
                            >
                                {copied ? (
                                    <Check className="h-4 w-4 text-green-600" />
                                ) : (
                                    <Copy className="h-4 w-4" />
                                )}
                            </Button>
                        </>
                    )}
                </div>
            </TableCell>
        </TableRow>
    );
}

export default SecondaryLink_row;
